export const WORKFLOWS_VIEW_PREFERENCES_KEY =
	'default/workflows_view_preferences'
